<div class="client-management-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ 'BUTTON.' + data.mode | translate }} {{ 'CLIENT.' + data.type | translate }} </span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3" class="p-4">
		@switch (data.type) {
		<!-- CLIENT form -->
		@case ('CLIENT') { @if (data.mode === 'NEW' || data.mode === 'EDIT') {
		<form [formGroup]="manageFormGroup" (submit)="save()">
			<div class="row pt-2">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'CLIENT.NAME' | translate }}</mat-label>
					<input matInput type="text" formControlName="name" cdkFocusInitial />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'CLIENT.DESCRIPTION' | translate }}</mat-label>
					<textarea matInput rows="3" style="max-height: 350px; resize: vertical;" formControlName="description" maxlength="5000"></textarea>
					<mat-hint align="end">{{ manageFormGroup.controls['description'].value?.length || 0 }}/5000</mat-hint>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'CLIENT.TAX_ID' | translate }}</mat-label>
					<input matInput type="text" formControlName="taxId" />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'CLIENT.LANG' | translate }}</mat-label>
					<mat-select color="primary" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="lang">
						@for (lang of availableLanguages; track $index) {
						<mat-option [value]="lang.code.toUpperCase()">{{ 'NAVBAR.LANGUAGES.' + lang.code.toUpperCase() | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<mat-form-field class="w-100 pb-3" appearance="outline">
				<mat-label>{{ 'CLIENT.PRICING_STATE' | translate }}</mat-label>
				<mat-select color="primary" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="foreignCountry">
					<mat-option [value]="false">{{ 'CLIENT.PRICING_STATE_0' | translate }}</mat-option>
					<mat-option [value]="true">{{ 'CLIENT.PRICING_STATE_1' | translate }}</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-checkbox class="w-100" color="primary" formControlName="showTags">{{ 'CLIENT.SHOW_TAGS' | translate }}</mat-checkbox>
			<mat-checkbox class="w-100" color="primary" formControlName="showSentiment">{{ 'CLIENT.SHOW_SENTIMENT' | translate }}</mat-checkbox>
			<mat-checkbox class="w-100" color="primary" formControlName="newAnalytics">{{ 'CLIENT.NEW_ANALYTICS' | translate }}</mat-checkbox>

			<div class="row">
				<mat-form-field class="py-3">
					<mat-label>{{ 'RESELLER.RESELLER' | translate }}</mat-label>
					<mat-select color="primary" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="reseller">
						@for (reseller of resellerList; track $index) {
						<mat-option [value]="reseller">{{ reseller?.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
		</form>
		} @else if (data.mode === 'DELETE') {
		<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ utils.getParameterByName(data.client, 'name') }}? </span>
		} }
		<!-- (END)CLIENT form -->
		<!-- ACCOUNT form -->
		@case ('ACCOUNT') { @if (data.mode === 'NEW' || data.mode === 'EDIT') {
		<form [formGroup]="manageFormGroup" (submit)="save()">
			<div class="row pt-2">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'CLIENT.IDENTIFIER' | translate }}</mat-label>
					<input matInput type="text" formControlName="identifier" cdkFocusInitial />
				</mat-form-field>
			</div>

			<!-- <div class="row">
				<mat-form-field class="pb-2">
					<mat-label>{{ 'CLIENT.PASSWORD' | translate }}</mat-label>
					<input matInput [type]="passwordVisible ? 'text' : 'password'" formControlName="password" autocomplete="current-password" />
					<button mat-icon-button matSuffix type="button" (click)="passwordVisible = !passwordVisible" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="passwordVisible">
						<mat-icon color="primary">{{ passwordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
					</button>
					@if (manageFormGroup.controls['password'].invalid) {
					<mat-error>{{ utils.getErrorMessage(manageFormGroup.controls['password']) | translate }}</mat-error>
					}
				</mat-form-field>
			</div> -->

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'CLIENT.NAME' | translate }}</mat-label>
					<input matInput type="text" formControlName="name" />
				</mat-form-field>
			</div>

			<!-- <div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'CLIENT.EMAIL' | translate }}</mat-label>
					<input matInput type="text" formControlName="email" />
				</mat-form-field>
			</div> -->

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'CLIENT.SCOPES' | translate }}</mat-label>
					<mat-select color="primary" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="scopes" multiple>
						@for (scope of scopes; track $index) {
						<mat-option [value]="scope">{{ 'ROLE.' + scope.toUpperCase() | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
		</form>
		} @else if (data.mode === 'DEACTIVATE') {
		<span> {{ 'NOTIFICATIONS.DEACTIVATE_CONFIRMATION_MESSAGE' | translate }} {{ data.item.identifier }}? </span>
		} @else if (data.mode === 'ACTIVATE') {
		<span> {{ 'NOTIFICATIONS.ACTIVATE_CONFIRMATION_MESSAGE' | translate }} {{ data.item.identifier }}? </span>
		} @else if (data.mode === 'DELETE') {
		<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ utils.getParameterByName(data.item, 'identifier') }}? </span>
		} }
		<!-- (END)ACCOUNT form -->
		<!-- SUBSCRIPTION form -->
		@case ('SUBSCRIPTION') { @if (data.mode === 'NEW' || data.mode === 'EDIT') {
		<form [formGroup]="manageFormGroup" (submit)="save()">
			<div class="row pt-2">
				<div class="row">
					<mat-form-field class="pb-3">
						<mat-label>{{ 'CLIENT.TYPE' | translate }}</mat-label>
						<select id="type" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select color="primary" id="type" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="type">
							@for (subscription of subscriptionTypes; track $index) {
							<mat-option [value]="subscription">{{ 'CLIENT.SUBSCRIPTION_TYPES.' + subscription | translate }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>

				@if(manageFormGroup.controls['type'].value === 'CLIPPING') {
				<div class="row">
					<mat-form-field class="pb-3">
						<mat-label>{{ 'CLIENT.EMAIL_SUBJECT' | translate }}</mat-label>
						<input matInput type="text" formControlName="emailSubject" />
					</mat-form-field>
				</div>

				<div class="row">
					<mat-form-field class="pb-3">
						<mat-label>{{ 'CLIENT.PDF_TITLE' | translate }}</mat-label>
						<input matInput type="text" formControlName="pdfTitle" />
					</mat-form-field>
				</div>

				<div class="row pb-3 d-flex flex-wrap">
					<mat-checkbox class="w-50" formControlName="aiSummary">
						<span style="margin-right: 4px;">{{ 'CLIENT.AI_SUMMARY' | translate }}</span>
						@if(manageFormGroup.controls['aiSummary'].value) {
							<span style="color: #999;">({{ (data.item?.aiSummaryTokens || 0) | number }})</span>
						}
					</mat-checkbox>
				</div>

				<div class="row pb-3 d-flex flex-wrap">
					<mat-checkbox class="w-50" formControlName="detailedClippingReport">
						<span>{{ 'CLIENT.DETAILED_REPORT' | translate }}</span>
					</mat-checkbox>

					@if(manageFormGroup.controls['detailedClippingReport'].value) {
					<mat-form-field class="w-50">
						<mat-label>{{ 'CLIENT.DETAILED_REPORT_TITLE' | translate }}</mat-label>
						<input matInput type="text" formControlName="detailedClippingReportTitle" />
					</mat-form-field>
					}
				</div>

				<!-- Viber known: enable + channel token + "show sentiment", CLIPPING-568 -
				     entirely separate from real-time (per-tag, further down) and per-tag sentiment. -->
				<div class="row pb-1">
					<span class="w-100" style="font-weight: 500;">{{ 'CLIENT.VIBER_NOTIFICATIONS' | translate }}</span>
				</div>
				<div class="row pb-3 d-flex flex-wrap">
					<mat-checkbox class="w-50" formControlName="viberEnabled">
						<span>{{ 'CLIENT.VIBER_ENABLED' | translate }}</span>
					</mat-checkbox>

					@if(manageFormGroup.controls['viberEnabled'].value) {
					<mat-checkbox class="w-50" formControlName="viberShowSentiment">
						<span>{{ 'CLIENT.VIBER_SHOW_SENTIMENT' | translate }}</span>
					</mat-checkbox>

					<mat-form-field class="w-100">
						<mat-label>{{ 'CLIENT.VIBER_CHANNEL_TOKEN' | translate }}</mat-label>
						<input matInput type="text" formControlName="viberChannelToken" />
						@if(data.item?.viberChannelTokenMasked) {
						<mat-hint>{{ 'CLIENT.VIBER_CHANNEL_TOKEN_CURRENT' | translate: { token: data.item?.viberChannelTokenMasked } }}</mat-hint>
						} @else {
						<mat-hint>{{ 'CLIENT.VIBER_CHANNEL_TOKEN_HINT' | translate }}</mat-hint>
						}
					</mat-form-field>

					@if(data.item?.viberConnectionError) {
					<div class="w-100 d-flex align-items-center" style="color:#b26a00; gap:6px;">
						<mat-icon style="font-size:20px; height:20px; width:20px;">warning</mat-icon>
						<span>{{ 'CLIENT.VIBER_CONNECTION_ERROR' | translate: { error: data.item?.viberConnectionError } }}</span>
					</div>
					}
					}
				</div>
				}

				<div class="row">
					<mat-form-field class="w-100" class="pb-3">
						<mat-label>{{ 'CLIENT.EMAIL_TO' | translate }}</mat-label>
						<mat-chip-grid #emailToGrid aria-label="E-mail selection">
							@for (email of selectedEmailsTo; track $index) {
							<mat-chip-row (removed)="manageEmails('emailTo', 'REMOVE', email)">
								{{ email }}
								<button matChipRemove [attr.aria-label]="'remove ' + email">
									<mat-icon>cancel</mat-icon>
								</button>
							</mat-chip-row>
							}
						</mat-chip-grid>
						<input
							#emailToInput
							formControlName="emailTo"
							[matChipInputFor]="emailToGrid"
							[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
							(matChipInputTokenEnd)="manageEmails('emailTo', 'ADD', $event)" />
						<!--
          [matAutocomplete]="autoEmailTo"
          <mat-autocomplete #autoEmailTo="matAutocomplete" (optionSelected)="manageEmails('emailTo', 'ADD', $event)">
          @for (email of filteredEmailsTo; track $index) {
          <mat-option [value]="email">{{ email }}</mat-option>
          }
        </mat-autocomplete> -->
					</mat-form-field>
				</div>

				<div class="row">
					<mat-form-field class="w-100" class="pb-3">
						<mat-label>{{ 'CLIENT.EMAIL_CC' | translate }}</mat-label>
						<mat-chip-grid #emailCcGrid aria-label="E-mail CC selection">
							@for (email of selectedEmailsCc; track $index) {
							<mat-chip-row (removed)="manageEmails('emailCc', 'REMOVE', email)">
								{{ email }}
								<button matChipRemove [attr.aria-label]="'remove ' + email">
									<mat-icon>cancel</mat-icon>
								</button>
							</mat-chip-row>
							}
						</mat-chip-grid>
						<input
							#emailCcInput
							formControlName="emailCc"
							[matChipInputFor]="emailCcGrid"
							[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
							(matChipInputTokenEnd)="manageEmails('emailCc', 'ADD', $event)" />
					</mat-form-field>
				</div>

				<div class="row">
					<mat-form-field class="w-100" class="pb-3">
						<mat-label>{{ 'CLIENT.EMAIL_BCC' | translate }}</mat-label>
						<mat-chip-grid #emailBccGrid aria-label="E-mail Bcc selection">
							@for (email of selectedEmailsBcc; track $index) {
							<mat-chip-row (removed)="manageEmails('emailBcc', 'REMOVE', email)">
								{{ email }}
								<button matChipRemove [attr.aria-label]="'remove ' + email">
									<mat-icon>cancel</mat-icon>
								</button>
							</mat-chip-row>
							}
						</mat-chip-grid>
						<input
							#emailBccInput
							formControlName="emailBcc"
							[matChipInputFor]="emailBccGrid"
							[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
							(matChipInputTokenEnd)="manageEmails('emailBcc', 'ADD', $event)" />
					</mat-form-field>
				</div>

				<div class="row">
					<div class="col">
						<mat-form-field class="pb-3 w-50 pe-1">
							<mat-label for="valid-from">{{ 'CLIENT.VALID_FROM' | translate }}</mat-label>
							<input matInput id="valid-from" [matDatepicker]="pickerFrom" formControlName="validFrom" [max]="manageFormGroup.controls['validTo'].value" />
							<mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
							<mat-datepicker #pickerFrom></mat-datepicker>
						</mat-form-field>

						<mat-form-field class="pb-3 w-50 ps-1">
							<mat-label for="valid-to">{{ 'CLIENT.VALID_TO' | translate }}</mat-label>
							<input matInput id="valid-to" [matDatepicker]="pickerTo" formControlName="validTo" [min]="manageFormGroup.controls['validFrom'].value" />
							<mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
							<mat-datepicker #pickerTo></mat-datepicker>
						</mat-form-field>
					</div>
				</div>

				<div class="row">
					<mat-form-field class="pb-3">
						<mat-label>{{ 'CLIENT.TAG_LIMIT' | translate }}</mat-label>
						<input matInput type="number" min="0" formControlName="tagLimit" />
						<mat-hint>{{ 'CLIENT.TAG_LIMIT_HINT' | translate }}</mat-hint>
					</mat-form-field>
				</div>

				<!-- <div class="row">
						<div class="col">
							<div class="d-flex gap-2 flex-row flex-wrap p-2">
								@for (tag of clientTags; track $index ) {
								<div [style.background-color]="utils.getParameterByName(tag, 'colorCode')" class="tag-item d-flex align-items-center list-item">
									<span>
										{{ utils.getParameterByLanguageScript(tag, 'name', true) }}
									</span>
								</div>
								}
							</div>
						</div>
					</div> -->
			</div>
			<!-- TAGS selection -->
			@if(data.mode === 'EDIT' && showTagsSection) {
			<div class="row">
				<mat-accordion #tagsAccordion="matAccordion" multi>
					@for (category of tagCategories; track $index ) {
					<mat-expansion-panel (opened)="accordionAction('open', category)" (closed)="accordionAction('close', category)" [expanded]="category.isOpened">
						<mat-expansion-panel-header>
							<mat-panel-title>
								<span>
									{{ utils.getParameterByName(category, 'value') }}
								</span>
							</mat-panel-title>
							<mat-panel-description> </mat-panel-description>
						</mat-expansion-panel-header>

						<div class="d-flex flex-row flex-wrap p-2">
							<span class="list-section w-100">
								<ul class="p-0 m-0">
									<ng-container formArrayName="clientTagsDetails">
										@for (tag of utils.getParameterByName(category, 'tags'); track tag.id) {
										<li class="d-flex align-items-start justify-content-between" [formGroupName]="tag.index">
											<mat-checkbox (change)="manageClientTag(tag.index, 'checked', $event)" formControlName="checked">
												<div class="d-flex">
													<div class="tag-item" [style.background-color]="tag.colorCode"></div>
													<span>{{ tag.value }}</span>
												</div>
											</mat-checkbox>

											@if (clientTagsDetails.controls[tag.index].get('checked')?.value) {
											<div class="w-50 d-flex justify-content-end align-items-start flex-wrap">
												@if(manageFormGroup.controls['type'].value === 'CLIPPING') {
												<mat-checkbox
													class="mt-1"
													formControlName="sentiment"
													matTooltip="{{ 'CLIENT.SENTIMENT' | translate }}"
													matTooltipPosition="below"
													(change)="manageClientTag(tag.index, 'sentiment', $event)">
												</mat-checkbox>

												<mat-form-field class="mt-1 mx-1 brand-kind-field" subscriptSizing="dynamic" appearance="outline">
													<mat-select
														formControlName="brandKind"
														[panelWidth]="null"
														matTooltip="{{ 'CLIENT.BRAND_KIND' | translate }}"
														matTooltipPosition="below"
														(selectionChange)="manageBrandKind(tag.index, $event)">
														<mat-option [value]="null">—</mat-option>
														<mat-option value="COMPANY">{{ 'CLIENT.COMPANY' | translate }}</mat-option>
														<mat-option value="COMPETITOR">{{ 'CLIENT.COMPETITOR' | translate }}</mat-option>
													</mat-select>
												</mat-form-field>
												}
												@if(manageFormGroup.controls['type'].value === 'CLIPPING' || manageFormGroup.controls['type'].value === 'TRANSCRIPTIONS') {
												<mat-checkbox
													class="mt-1"
													formControlName="realTime"
													matTooltip="{{ 'CLIENT.REAL_TIME' | translate }}"
													matTooltipPosition="below"
													(change)="manageClientTag(tag.index, 'realTime', $event)"></mat-checkbox>

												@if(clientTagsDetails.controls[tag.index].get('realTime')?.value) {
												<button
													mat-icon-button
													type="button"
													color="inherit"
													matTooltip="{{ 'CLIENT.REAL_TIME_EMAILS' | translate }}"
													matTooltipPosition="below"
													class="mx-1 report-icon"
													(click)="openEmailDialog(tag.index, clientTagsDetails.controls[tag.index].get('realTimeEmails')?.value)">
													<mat-icon>description</mat-icon>
												</button>
												}
												} @if(manageFormGroup.controls['type'].value === 'CLIPPING') {
												<!-- CLIPPING-568: independent of real-time above - a client can have either, both, or
												     neither checked on the same tag. Gates posting this news item to the client's Viber channel. -->
												<mat-checkbox
													class="mt-1"
													formControlName="viber"
													matTooltip="{{ 'CLIENT.VIBER' | translate }}"
													matTooltipPosition="below"
													(change)="manageClientTag(tag.index, 'viber', $event)"></mat-checkbox>
												}
												@if(manageFormGroup.controls['type'].value === 'CLIPPING') {
												<!-- <mat-checkbox
													formControlName="sentiment"
													matTooltip="{{ 'CLIENT.SENTIMENT' | translate }}"
													matTooltipPosition="below"
													(change)="manageClientTag(tag.index, 'sentiment', $event)"></mat-checkbox> -->

												<div class="row w-75">
													<mat-form-field class="col pb-2">
														<mat-label>{{ 'CLIENT.PRIORITY' | translate }}</mat-label>
														<input matInput type="number" formControlName="priority" (input)="manageClientTag(tag.index, 'priority', undefined, $event)" />
													</mat-form-field>
												</div>
												}
											</div>
											}
										</li>
										<!-- <mat-divider class="w-75 mb-2"></mat-divider> -->
										}
									</ng-container>
								</ul>
							</span>
						</div>
					</mat-expansion-panel>
					}
				</mat-accordion>
			</div>
			}
			<!-- (END)TAGS selection -->
		</form>
		} @else if (data.mode === 'DELETE') {
		<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ 'CLIENT.SUBSCRIPTION_TYPES.' + utils.getParameterByName(data.client, 'type') | translate }}? </span>
		} }
		<!-- (END)SUBSCRIPTION form -->
		}
	</mat-dialog-content>

	<mat-dialog-actions class="px-4">
		<mat-divider class="w-100 my-2"></mat-divider>
		<div class="d-flex justify-content-between align-items-center pt-0 w-100">
			<div>
				@if (data.type === 'SUBSCRIPTION' && (data.mode === 'NEW' || data.mode === 'EDIT')) {
				<button mat-icon-button
					type="button"
					[color]="sendAccountCreationEmail ? 'primary' : ''"
					[style.color]="sendAccountCreationEmail ? '' : '#9e9e9e'"
					(click)="toggleSendAccountCreationEmail()"
					matTooltip="{{ (sendAccountCreationEmail ? 'CLIENT.DO_SEND_ACCOUNT_CREATION_EMAIL' : 'CLIENT.DONT_SEND_ACCOUNT_CREATION_EMAIL') | translate }}">
					<mat-icon>{{ sendAccountCreationEmail ? 'mark_email_read' : 'unsubscribe' }}</mat-icon>
				</button>
				}
			</div>
			<div class="gap-2 d-flex">
				<button mat-flat-button type="submit" color="primary" [disabled]="!checkFormValidity()" (click)="save()">
					{{ 'BUTTON.CONFIRM' | translate }}
				</button>
				<button mat-flat-button type="button" color="primary" (click)="closeDialog()">
					{{ 'BUTTON.CANCEL' | translate }}
				</button>
			</div>
		</div>
	</mat-dialog-actions>
</div>
